export const SET_FORM = 'set_form',
  RESET_FORM = 'reset_form',
  SEND_FORM = 'send_form',
  FORM_ERROR = 'form_error';



// WEBPACK FOOTER //
// ./src/client/actions/types.js